import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { MapPin } from "lucide-react";

const cols = [
  {
    title: "Platform",
    links: [
      { label: "Guest", to: "/platform#guest" },
      { label: "Staff", to: "/platform#staff" },
      { label: "HOP Dashboard", to: "/platform#hop" },
      { label: "Integrations", to: "/platform#integrations" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Use cases", to: "/use-cases" },
      { label: "Roadmap", to: "/roadmap" },
      { label: "Demo", to: "/demo" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/[0.08] bg-gradient-to-b from-brand-ink to-brand-purpleDeep"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-6 text-white/70 max-w-sm leading-relaxed">
            One platform for modern hotel operations. Connect guests, staff and
            management through one intelligent hospitality platform.
          </p>
          <div className="mt-6 flex items-center gap-2 text-[11px] font-display uppercase tracking-[0.24em] text-white/60 font-bold">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulseGlow" />
            ISO 27001 · Cloud native
          </div>
        </div>

        {cols.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <div className="font-display text-[11px] uppercase tracking-[0.28em] text-white/60 mb-4 font-bold">
              {col.title}
            </div>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-white/80 hover:text-white text-[14px] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-4">
          <div className="font-display text-[11px] uppercase tracking-[0.28em] text-white/60 mb-4 font-bold">
            Get in touch
          </div>
          <div className="space-y-4">
            <div>
              <div className="flex items-center gap-1.5 text-white/60 text-[11px] font-bold uppercase tracking-widest">
                <MapPin size={12} /> MENA regional office
              </div>
              <div className="mt-1 text-white/85 text-[13.5px] leading-relaxed">
                iNPLASS iNFOTECH · 1/108, Bu Shaqer Tower B, Garhoud, Dubai, UAE
                <br />
                <span className="text-white/70">+971 4 326 000 1</span>
              </div>
            </div>
            <div>
              <div className="flex items-center gap-1.5 text-white/60 text-[11px] font-bold uppercase tracking-widest">
                <MapPin size={12} /> Corporate office
              </div>
              <div className="mt-1 text-white/85 text-[13.5px] leading-relaxed">
                iNPLASS iNFOTECH · 8 The Green STE R, Dover DE 19901,
                Delaware, USA
              </div>
            </div>
            <a
              href="mailto:info@inplass.com"
              className="inline-block text-white hover:text-brand-orange text-[14px] font-semibold underline underline-offset-4 decoration-brand-orange"
              data-testid="footer-email-link"
            >
              info@inplass.com
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.08]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-white/60 text-[13px]">
            © {new Date().getFullYear()} iNPLASS iNFOTECH. All rights reserved.
          </div>
          <div className="font-display text-[11px] uppercase tracking-[0.28em] text-white/60 font-bold">
            Let&apos;s hotel.
          </div>
        </div>
      </div>
    </footer>
  );
}
